/**
 * Business-Related Routes
 *
 * Routes for business overview, API docs, contact, and pricing
 */

import React from "react";
import { Route } from "react-router-dom";
import {
  BusinessOverview,
  ApiDocumentation,
  ContactSales,
  PricingPage,
} from "../lazyComponents";
import { getCommonProps } from "./routeConfig";

/**
 * Gets all business-related routes
 * @param {Object} props - Props from parent component
 * @returns {Array} Array of Route elements
 */
export const getBusinessRoutes = ({ getHeaderStyleProps, userData }) => {
  const headerStyleProps = getHeaderStyleProps();

  return [
    <Route
      key="business-overview"
      path="/business/overview"
      element={<BusinessOverview {...headerStyleProps} {...getCommonProps()} />}
    />,
    <Route
      key="business-api"
      path="/business/api"
      element={<ApiDocumentation {...headerStyleProps} {...getCommonProps()} />}
    />,
    <Route
      key="business-contact"
      path="/business/contact"
      element={
        <ContactSales
          {...headerStyleProps}
          {...getCommonProps()}
          actualUsername={userData?.username}
          userEmail={userData?.email}
          fullName={userData?.fullName}
        />
      }
    />,
    <Route
      key="business-pricing"
      path="/business/pricing"
      element={<PricingPage {...headerStyleProps} {...getCommonProps()} />}
    />,
  ];
};
